import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  areas: { count: 0, rows: [] },
  loading: false,
  checkDelete: {},
};

const requestAreasStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchAreasSuccess = (state, action) => {
  return updateObject(state, {
    areas: action.areas,
    loading: false
  });
};

const requestAreasFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteAreasSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteAreasSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateAreasSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postAreasSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_AREAS_START: return requestAreasStart(state, action);
    case actionTypes.FETCH_AREAS_SUCCESS: return fetchAreasSuccess(state, action);
    case actionTypes.REQUEST_AREAS_FAIL: return requestAreasFail(state, action);
    case actionTypes.DELETE_AREAS_SUCCESS: return deleteAreasSuccess(state, action);
    case actionTypes.CHECK_DELETE_AREAS_SUCCESS: return checkDeleteAreasSuccess(state, action);
    case actionTypes.UPDATE_AREAS_SUCCESS: return updateAreasSuccess(state, action);
    case actionTypes.POST_AREAS_SUCCESS: return postAreasSuccess(state, action);

    default: return state;
  }
};

export default reducer;